import { render, staticRenderFns } from "./icon-instagram_3.vue?vue&type=template&id=4224a2f0"
import script from "./icon-instagram_3.vue?vue&type=script&lang=js"
export * from "./icon-instagram_3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports